// import { ModuleRoutes } from './routes.constant';

export const menuOption = [
  /******top navigation********/
  {
    src: "../../../assets/images/icons8-new-25.png", title: 'New Recall', name: 'New Recall',  isMenuVisible: true,
    // url: ModuleRoutes.Dashboard.Url,
    config: { showSubMenu: false, highlight: false, displayBottom: false},
    subMenuItems: [],
    subMenuHeader: ''
  },
  {
    src: "../../../assets/images/patients_icon_normal.png", title: 'All Recalls', name: 'All Recalls', url: null, isMenuVisible: true,
    config: { showSubMenu: true, highlight: false, displayBottom: false},
    // subMenuItems: [
    //   {
    //   title: 'Schedule Procedure', 
    //   name: 'schedule-procedure', 
    //   url: ModuleRoutes.ScheduleProcedure.Url, 
    //   isMenuVisible: true,
    //   config: { highlight: false}
    // },
    // {
    //   title: 'Directory', 
    //   name: 'directory', 
    //   url: ModuleRoutes.Directory.Url, 
    //   isMenuVisible: true,
    //   config: { highlight: false}
    // }
    // ],
    // subMenuHeader: ''
  }
  ,{
    src: "../../../assets/images/icons8-new-25.png", title: 'Archives', name: 'Archives',  isMenuVisible: true,
    // url: ModuleRoutes.Dashboard.Url,
    config: { showSubMenu: false, highlight: false, displayBottom: false},
    subMenuItems: [],
    subMenuHeader: ''
  },
  /******top navigation********/


];

